var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    stroke: "#1554FF",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99661 7.90004L7.39389 2.50008C7.87074 2.50008 8.32806 2.68972 8.66524 3.02728C9.00243 3.36484 9.19186 3.82268 9.19186 4.30006V6.70005H12.7878C12.9615 6.69808 13.1336 6.73395 13.2922 6.80518C13.4507 6.87641 13.5918 6.98129 13.7059 7.11256C13.8199 7.24382 13.904 7.39834 13.9525 7.56539C14.0009 7.73245 14.0125 7.90806 13.9864 8.08004L12.9556 13.48C12.9122 13.7661 12.7671 14.027 12.5468 14.2144C12.3265 14.4018 12.046 14.5033 11.757 14.5H4.99661M4.99661 7.90004V14.5M4.99661 7.90004H3.19864C2.88074 7.90004 2.57586 8.02647 2.35107 8.25151C2.12629 8.47655 2 8.78178 2 9.10003V13.3C2 13.6183 2.12629 13.9235 2.35107 14.1485C2.57586 14.3736 2.88074 14.5 3.19864 14.5H4.99661",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.016524e07074598dadf06d331b404d2b.svg";
export { ForwardRef as ReactComponent };